import { render, staticRenderFns } from "./paypalPayment.html?vue&type=template&id=000271f4&scoped=true&"
import script from "./paypalPayment.js?vue&type=script&lang=js&"
export * from "./paypalPayment.js?vue&type=script&lang=js&"
import style0 from "./paypalPayment.css?vue&type=style&index=0&id=000271f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000271f4",
  null
  
)

export default component.exports